import React, { useState, useEffect } from "react";
import './Navbar.css';
import Logo from '../Assets/logo.jpg';
import homeIcon from '../Assets/home.png';
import aboutIcon from '../Assets/about.png';
import contactIcon from '../Assets/contact.png';
import projectsIcon from '../Assets/projects.png';
import Volunteer from '../Assets/volunteer.png';
import { FaBars, FaTimes } from 'react-icons/fa';
import { FaUserShield } from 'react-icons/fa';
import { FaRegCalendarAlt } from 'react-icons/fa';

function Navbar({ isLoggedIn = false }) {
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    
    // Close the mobile menu when a link is clicked
    const handleLinkClick = () => {
        setIsMobileOpen(false);
    };
    
    // Close the mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            const nav = document.querySelector('.nav');
            const hamburger = document.querySelector('.hamburger');
            
            if (isMobileOpen && 
                !nav.contains(event.target) && 
                !hamburger.contains(event.target)) {
                setIsMobileOpen(false);
            }
        };
        
        // Add event listener when the mobile menu is open
        if (isMobileOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            // Prevent body scrolling when menu is open
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        
        // Clean up
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'auto';
        };
    }, [isMobileOpen]);

    return (
        <nav className="nav">
            <h1>
                <a href="/" className="site-title">
                    <img src={Logo} alt="Logo" className="VIIlogo" />
                    Volunteers Impact Initiative
                </a>
            </h1>
            
            {/* Desktop Navigation */}
            <ul className="nav-links">
                <li><a href="/"><img src={homeIcon} alt="Home Icon" /> Home</a></li>
                <li><a href="/About"><img src={aboutIcon} alt="About Icon" /> About</a></li>
                <li><a href="Contact"><img src={contactIcon} alt="Contact Icon" />Contact</a></li>
                <li><a href="/Projects"><img src={projectsIcon} alt="Projects Icon" />Projects</a></li>
                <li>
                    <a href="/Events">
                        <span className="admin-link-icon" aria-hidden="true">
                            <FaRegCalendarAlt size={18} />
                        </span>
                        Events
                    </a>
                </li>
                <li><a href="/VolunteerNow"><img src={Volunteer} alt="Volunteer Icon" />Become a Volunteer</a></li>
                {isLoggedIn && (
                    <li>
                        <a href="/admin/login" className="admin-link">
                            <span className="admin-link-icon" aria-hidden="true">
                                <FaUserShield size={18} />
                            </span>
                            Admin
                        </a>
                    </li>
                )}
            </ul>
            
            {/* Mobile Navigation Overlay */}
            <div className={`mobile-nav-overlay ${isMobileOpen ? 'active' : ''}`} onClick={() => setIsMobileOpen(false)}></div>
            
            <div className={`mobile-nav-menu ${isMobileOpen ? 'active' : ''}`}>
                <div className="mobile-nav-header">
                    <img src={Logo} alt="Logo" className="mobile-logo" />
                    <h2>Volunteers Impact Initiative</h2>
                </div>
                <ul className="mobile-nav-links">
                    <li><a href="/" onClick={handleLinkClick}><img src={homeIcon} alt="Home Icon" /> Home</a></li>
                    <li><a href="/About" onClick={handleLinkClick}><img src={aboutIcon} alt="About Icon" /> About</a></li>
                    <li><a href="Contact" onClick={handleLinkClick}><img src={contactIcon} alt="Contact Icon" />Contact</a></li>
                    <li><a href="/Projects" onClick={handleLinkClick}><img src={projectsIcon} alt="Projects Icon" />Projects</a></li>
                    <li>
                        <a href="/Events" onClick={handleLinkClick}>
                            <span className="admin-link-icon" aria-hidden="true">
                                <FaRegCalendarAlt size={18} />
                            </span>
                            Events
                        </a>
                    </li>
                    <li><a href="/VolunteerNow" onClick={handleLinkClick}><img src={Volunteer} alt="Volunteer Icon" />Become a Volunteer</a></li>
                    {isLoggedIn && (
                        <li>
                            <a href="/admin/login" onClick={handleLinkClick} className="admin-link">
                                <span className="admin-link-icon" aria-hidden="true">
                                    <FaUserShield size={18} />
                                </span>
                                Admin
                            </a>
                        </li>
                    )}
                </ul>
            </div>
            
            <div className="hamburger" onClick={() => setIsMobileOpen(!isMobileOpen)}>
                {isMobileOpen ? <FaTimes size={30} /> : <FaBars size={30} />}
            </div>
        </nav>
    );
}

export default Navbar;